import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import { RemoveSubscriptionBalance } from "../../services/PackageLog/PackageLog";

const ConfirmTransferAmount = ({
  confirmTransferAmountModalVisible,
  setConfirmTransferAmountModalVisible,
  confirmTransferAmount,
  sendDataToConfirmTransferAmount,
  storeLocalData,
  brandId,
  storeCustomerId
}) => {
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const handleConfirmation = () => {
    setIsSubmitButtonPressed(true);
    RemoveSubscriptionBalance(brandId, storeCustomerId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          if (res.status === true) {
            sendDataToConfirmTransferAmount({
              success: true,
            });
            setIsSubmitButtonPressed(false);
            setConfirmTransferAmountModalVisible(false);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
    sendDataToConfirmTransferAmount({
      success: false,
    });
    setConfirmTransferAmountModalVisible(!confirmTransferAmountModalVisible);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={confirmTransferAmountModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!confirmTransferAmountModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column  "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>

              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Transfer To Wallet
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>
            <div className="flex-auto mt-2 mx-4">
              <p
                className=" text-center font-semibold text-xl block"
                style={{ color: "blue" }}
              >
                Please confirm: Do you want to transfer {storeLocalData?.currencySymbol + " " + confirmTransferAmount} ?
              </p>
            </div>

            <div className="flex-auto mt-2 mx-4">
              <p
                className=" text-center  text-md block"
                style={{ color: "red" }}
              >
                Before proceeding with the transfer, please ensure that all subscription bills have been closed.
              </p>
            </div>

            <div className="flex flex-1 mt-2">
              <Button
                onClick={handleConfirmation}
                disabled={isSubmitButtonPressed}
                className="flex-1 mt-1 mb-3 mx-4 p-1 border-round-xl "
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  Yes
                </p>
              </Button>
              <Button
                onClick={() => {
                  setIsSubmitButtonPressed(false);
                  sendDataToConfirmTransferAmount({
                    success: false,
                    confirmTransferAmountRes: "",
                  });
                  setConfirmTransferAmountModalVisible(
                    !confirmTransferAmountModalVisible
                  );
                }}
                disabled={isSubmitButtonPressed}
                className="flex-1 mt-1 mb-3 mx-4 p-1 border-round-xl "
              >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  No
                </p>
              </Button>
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default ConfirmTransferAmount;
